import React from 'react';
import propTypes from 'prop-types';
import { InputAdornment, IconButton } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';

const InputButton = ({ visibility, setVisibility }) => (
  <InputAdornment position="end">
    <IconButton
      aria-label="Toggle password visibility"
      onClick={() => { setVisibility(!visibility); }}
    >
      {visibility ? <Visibility /> : <VisibilityOff />}
    </IconButton>
  </InputAdornment>
);
InputButton.propTypes = {
  visibility: propTypes.bool,
  setVisibility: propTypes.func.isRequired,
};

InputButton.defaultProps = {
  visibility: false,
};
export default InputButton;
